<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-divider type="vertical" class="item" />

                <a-button class="item" icon="check" @click="on_read_all">全部已读</a-button>

                <span class="item selected" v-if="selected_row_keys.length">
                    已选中：
                    <span class="num">{{ selected_row_keys.length }}</span
                    >条
                </span>
            </div>

            <div class="right-items"></div>
        </div>

        <!-- 主体表格 -->
        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
                :scroll="{ x: true }"
                @change="(e) => on_pagination_change(e, path)"
            >
                <!-- 注册信息 -->
                <template slot="created" slot-scope="text">
                    <span v-html="$options.filters['friendly'](moment(text * 1000).format('YYYY-MM-DD HH:mm'))"></span>
                </template>

                <template slot="action" slot-scope="text, record">
                    <a-button size="small" style="margin-right: 5px" @click="on_view(record)">查看客户</a-button>
                    <a-button size="small" @click="on_read(record)" :disabled="!!record.is_read">已读</a-button>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
    // import advance_search from "./advance_search.vue";

    import common_pagination from "../../../mixins/common_pagination.js";

    import commonjs from "../mixins/common";
    import moment from "moment";

    export default {
        mixins: [common_pagination, commonjs],

        data() {
            return {
                path: "/member/distribute",
                loading: false,
                data_source: [],
                trigger: null,
                wd: null,
                columns: [
                    {
                        dataIndex: "from_user.name",
                        title: "操作人",
                        width: 150,
                    },
                    {
                        dataIndex: "count",
                        title: "分配客户数量",
                        width: 150,
                    },
                    {
                        dataIndex: "created_at",
                        title: "分配时间",
                        width: 150,
                        scopedSlots: {
                            customRender: "created",
                        },
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                        scopedSlots: {
                            customRender: "remark",
                        },
                    },
                    {
                        dataIndex: "action",
                        title: "操作",
                        width: 200,
                        align: "center",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        watch: {
            $route() {
                this.selected_row_keys = [];
                this.load();
            },
        },
        mounted() {
            this.load();
        },
        created() {
            this.$store.commit("change_state", {
                name: "member_sidebar_selected",
                value: "distribute",
            });
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/member/distribute?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;

                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                            //每次加载完数据后再次统计
                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_view(record) {
                this.on_read(record);
                this.redirect("/member/whole?distribute_id=" + record.id);
            },
            on_read(record) {
                this.$http
                    .post(`/member/read_distribute`, { distribute_id: record.id })
                    .then((res) => {
                        if (res.success) {
                            this.load_stat();
                            this.load();
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_read_all() {
                this.$http
                    .post(`/member/read_distribute`, { scope: "whole" })
                    .then((res) => {
                        if (res.success) {
                            this.load_stat();
                            this.load();
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
        },
    };
</script>

<style lang="less" scoped>
    .framework-container {
        .framework-body {
            position: absolute;
            left: 200px;
            right: 0;
            bottom: 0;
            top: 0;
            .main {
                overflow-y: auto;
                position: absolute;
                top: 57px;
                left: 0;
                right: 0;
                bottom: 0;

                .contact {
                    width: 110px;
                    font-size: 12px;
                }

                .parent-render {
                    .parent {
                        font-size: 12px;
                        color: #00000080;
                    }
                    .child {
                        font-size: 12px;
                    }
                }
                .info {
                    .name {
                        margin-bottom: 2px;
                        font-size: 13px;
                    }
                    .qy {
                        font-size: 12px;
                        .anticon {
                            margin-right: 2px;
                        }
                    }
                }
            }
        }
    }

    .ant-dropdown-menu-item {
        display: flex;
        align-items: center;
    }
</style>
